// extracted by mini-css-extract-plugin
module.exports = {"width":"home_width__Fn_hm","hero-text":"home_hero-text__2LMkp","wrapper":"home_wrapper__dUnEZ","intro-text":"home_intro-text__gkTXN","body-bg":"home_body-bg__oJF6X"};